/**
 * Created by mykurisu on 2018/1/3.
 */
import React from 'react'
import {Toast} from 'react-weui'
import axios from 'axios'
import '../../css/page/MywkPage.css'


class CalendarItemHead extends React.Component {
    render() {
        return (
            <div className="main__block-head">
                {this.props.content}
            </div>
        )
    }
}

class CalendarItem extends React.Component {

    renderType() {
        switch (this.props.type) {
            case 'pre':
                return 'main__block-not';
                break;
            case 'next':
                return 'main__block-not';
                break;
            case 'selected':
                return 'main__block-today';
                break;
            default:
                return ''
        }
    }

    render() {
        return (
            <div className={'main__block ' + this.renderType()}
                 onClick={this.props.type === 'normal' ? () => this.props.handleChangeDay(this.props.content) : null}>
                {this.props.content}
                {this.props.has_lecture &&
                <div className="main__block-piont"></div>
                }
            </div>
        )
    }
}

class Calendar extends React.Component {

    constructor() {
        super();
        this.state = {
            // 日历日期初始化
            nowYear: new Date().getFullYear(),
            nowMonth: new Date().getMonth(),
            nowDate: new Date().getDate(),
            nowDay: new Date().getDay(),
            // 当前展现的日历数据
            showMountData: null,
            // 当前所选数据
            selectedYear: new Date().getFullYear(),
            selectedMonth: new Date().getMonth(),
            selectedDate: new Date().getDate(),
            // displayDaysPerMonth后的数据
            totalMountData: [],
            // 有课的日期时间戳
            hasLecture: {},
            // 不可以重复请求多次
            is_loading_data: false
        }
    }

    componentDidMount() {
        this.handleThingsForDay(new Date().getFullYear(), this.state.nowMonth)
    }

    displayDaysPerMonth(year) {
        //定义每个月的天数，如果是闰年第二月改为29天
        let daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        if ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
            daysInMonth[1] = 29
        }

        let daysPreMonth = [].concat(daysInMonth);
        daysPreMonth.unshift(daysPreMonth.pop());

        let addDaysFromPreMouth = new Array(12)
            .fill(null)
            .map((item, index) => {
                let day = new Date(year, index, 1).getDay();
                if (day === 0) {
                    return 6
                } else {
                    return day - 1
                }
            })

        // console.log(addDaysFromPreMouth)

        let total_calendar_list = new Array(12)
            .fill([])
            .map((mouth, mouthIndex) => {
                let addDays = addDaysFromPreMouth[mouthIndex] + 1,
                    daysCount = daysInMonth[mouthIndex],
                    daysCountPre = daysPreMonth[mouthIndex],
                    mouthDate = [];

                if (addDays >= 7) {
                    addDays = addDays - 7
                }

                for (; addDays > 0; addDays--) {
                    let obj = {
                        content: daysCountPre--,
                        type: 'pre'
                    };

                    mouthDate.unshift(obj)
                }

                for (let i = 0; i < daysCount;) {
                    let obj = {
                        content: ++i,
                        type: 'normal'
                    };

                    mouthDate.push(obj)
                }
                if (mouthDate.length > 35) {
                    for (let i = 42 - mouthDate.length, j = 0; j < i;) {
                        let obj = {
                            content: ++j,
                            type: 'next'
                        };

                        mouthDate.push(obj)
                    }
                } else {
                    for (let i = 35 - mouthDate.length, j = 0; j < i;) {
                        let obj = {
                            content: ++j,
                            type: 'next'
                        };

                        mouthDate.push(obj)
                    }
                }
                return mouthDate
            })

        this.setState({
            totalMountData: total_calendar_list
        })

        return total_calendar_list
    };

    handleThingsForDay(year, mouth) {
        let arr = this.displayDaysPerMonth(year)[mouth]
        let raw_mouth = mouth + 1 > 9 ? mouth + 1 : `0${mouth + 1}`;
        let raw_day = new Date().getDate() > 9 ? new Date().getDate() : `0${new Date().getDate()}`;
        let getUrl = '';
        let now = Date.parse(new Date(`${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`));
        let select_time = Date.parse(new Date(`${this.state.selectedYear}/${raw_mouth}/${raw_day}`));

        this.setState({
            showMountData: arr
        }, () => {
            if (select_time < now){
                return
            }

            getUrl = `/api/my/lecture_calendar/?since_date=${year}-${raw_mouth}-01`;

            if (year === new Date().getFullYear() && mouth === new Date().getMonth()){
                getUrl = `/api/my/lecture_calendar/?since_date=${year}-${raw_mouth}-${raw_day}`;
            }


            this.setState({
                is_loading_data: true
            })

            axios.get(getUrl)
                .then(res => {
                    if (res.data.code === 0){
                        this.setState({
                            hasLecture: res.data.data
                        }, () => {
                            for (let i = 0;i < arr.length;i++){


                                if (arr[i].type !== 'pre' && arr[i].type !== 'next'){
                                    let time = Date.parse(new Date(`${year}/${raw_mouth}/${arr[i].content}`)) / 1000
                                    if (this.state.hasLecture[time]){
                                        arr[i].has_lecture = true
                                    }
                                }

                            }
                            this.setState({
                                showMountData: arr,
                                is_loading_data: false
                            })
                        })
                    }else {
                        this.setState({
                            is_loading_data: false
                        })
                    }
                })

        })
    }

    handlePreMonth() {
        if (this.state.selectedMonth === 0) {
            let year = this.state.selectedYear - 1;
            let month = 11;
            this.setState({
                selectedMonth: month,
                selectedYear: year,
                // selectedDate: this.state.nowDate
            }, () => {
                this.handleThingsForDay(this.state.selectedYear, month)
            })
        } else {
            let month = this.state.selectedMonth - 1;
            this.setState({
                selectedMonth: month,
                // selectedDate: this.state.nowDate
            }, () => {
                this.handleThingsForDay(this.state.selectedYear, month)
            })
        }

    }

    handleNextMonth() {
        if (this.state.selectedMonth === 11) {
            let year = this.state.selectedYear + 1;
            let month = 0;
            this.setState({
                selectedMonth: month,
                selectedYear: year,
                // selectedDate: this.state.nowDate
            }, () => {
                this.handleThingsForDay(this.state.selectedYear, month)
            })
        } else {
            let month = this.state.selectedMonth + 1;
            this.setState({
                selectedMonth: month,
                // selectedDate: this.state.nowDate
            }, () => {
                this.handleThingsForDay(this.state.selectedYear, month)
            })
        }
    }

    handleChangeDay(content) {
        let raw_mouth = this.state.selectedMonth + 1 > 9 ? this.state.selectedMonth + 1 : `0${this.state.selectedMonth + 1}`;
        let raw_day = content > 9 ? content : `0${content}`;

        let now = Date.parse(new Date(`${new Date().getFullYear()}/${new Date().getMonth() + 1}/${new Date().getDate()}`));
        let select_time = Date.parse(new Date(`${this.state.selectedYear}/${raw_mouth}/${raw_day}`));

        if (select_time >= now){
            this.props.handleChangeDayData(`${this.state.selectedYear}-${raw_mouth}-${raw_day}`)
        }else {
            this.props.handleRemoveList()
        }

        this.setState({
            selectedDate: content
        }, () => {
            let list = [].concat(this.state.showMountData);
            list.find((item) => {
                if (item.type === 'selected') {
                    item.type = 'normal'
                }

                if (this.state.selectedDate === item.content && item.type === 'normal') {
                    item.type = 'selected'
                }
            });
            this.setState({
                showMountData: list
            })
        })
    }

    render() {
        return (
            <div className="mywk__calendar">

                <Toast show={this.state.is_loading_data} icon="loading">加载中</Toast>

                <div className="calendar">

                    <div className="calendar__header">
                        <div className="header__pre" onClick={this.state.is_loading_data ? null : () => this.handlePreMonth()}>

                        </div>
                        <div className="header__title">
                            {this.state.selectedMonth + 1}月 {this.state.selectedYear}年
                        </div>
                        <div className="header__next" onClick={this.state.is_loading_data ? null : () => this.handleNextMonth()}>

                        </div>
                    </div>


                    <div className="calendar__main">
                        <CalendarItemHead content="日"/>
                        <CalendarItemHead content="一"/>
                        <CalendarItemHead content="二"/>
                        <CalendarItemHead content="三"/>
                        <CalendarItemHead content="四"/>
                        <CalendarItemHead content="五"/>
                        <CalendarItemHead content="六"/>


                        {this.state.showMountData &&
                        this.state.showMountData.map((item, index) => {
                                if ((item.type === 'normal') && (item.content === this.state.selectedDate) && (this.state.nowMonth === this.state.selectedMonth) && (this.state.nowYear === this.state.selectedYear)) {
                                    item.type = 'selected'
                                }
                                return (
                                    <CalendarItem
                                        key={index}
                                        has_lecture={item.has_lecture}
                                        content={item.content}
                                        type={item.type}
                                        handleChangeDay={(content) => this.handleChangeDay(content)}
                                    />
                                )
                            }
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

export default Calendar



// WEBPACK FOOTER //
// ./src/pages/mywkPage/Calendar.js